module.exports = __webpack_public_path__ + "static/media/cka.1824b3fc.png";